export default __webpack_public_path__ + "images/78ec078e55d9804d6461801f46c323da.png";